const WATCHED_EVENTS = ["pointerdown", "mousemove", "keyup"];

let promise;

/**
 * Returns a promise that will resolve when the user makes some interaction (key
 * press, mouse move, physical contact, click).
 */
export function watch() {
	if (!promise) {
		promise = new Promise(resolve => {
			const eventListener = event => {
				WATCHED_EVENTS.forEach(eventName => {
					document.removeEventListener(eventName, eventListener);
				});
				resolve(event);
			};
			WATCHED_EVENTS.forEach(eventName => {
				document.addEventListener(eventName, eventListener);
			});
		});
	}
	return promise;
}
